export default "__VITE_ASSET__CYhiaI2T__"